module.exports = __webpack_public_path__ + "img/icon-trash.a46b830c.svg";